<template>
    <main-layout :hide-alerts="true" :containerFluid="true">
        <template v-slot:header>
            <v-toolbar-title class="d-flex justify-space-between align-center">
                <h1 class="text-truncate font-weight-bold text-h4">{{ $t('My Trips') }}</h1>
            </v-toolbar-title>
        </template>
        <template v-slot:body>
            <div
                v-if="(travelPlans && !travelPlans.length) && !isLoading"
                class="pa-3 d-flex flex-column my-travel-plans-guide-empty"
            >
                <div class="d-flex align-center">
                    <v-icon>mdi-map-outline</v-icon>
                    <p class="mb-0 ml-2 mr-4 text-subtitle-1">
                        {{ $t('travel_plans.empty_state') }}.
                    </p>
                </div>
                <div class="mt-6">
                    <v-btn
                        outlined
                        @click="goToPlanBuilder"
                        class="my-travel-plans-guide-create-btn"
                    >
                        + {{ $t('Create travel plan') }}
                    </v-btn>
                </div>
            </div>

            <template v-if="travelPlans && travelPlans.length">
                <travel-plans-in-table
                    :travel-plans="travelPlans"
                    class="my-travel-plans-guide-table"
                    @deleted="load"
                />
                <pagination
                    :resource="pagination"
                    :overwrite-path="url"
                    @load="load"
                />
            </template>
        </template>
    </main-layout>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import Pagination from '@/components/Pagination.vue';
import TravelPlansInTable from '@/components/travel-plans/TravelPlansInTable.vue';
import startMyTravelPlansGuide from '@shared/user-onboarding-guides/MyTravelPlansPageGuide';

export default {
  components: {
    Pagination,
    TravelPlansInTable,
  },
  data() {
    return {
      travelPlans: [],
      pagination: {},
      url: '/my-travel/travel-plans',
    };
  },
  mounted() {
    this.$title = this.$t('My Trips');
    this.load();
  },
  computed: {
    ...mapGetters(['user']),
    isLoading() {
      return this.$store.getters.loading;
    },
  },
  methods: {
    goToPlanBuilder() {
      window.location.href = `${process.env.VUE_APP_APP_URL}${this.$i18n.locale === 'sr' ? '/sr/planer-putovanja' : '/travel-planner'}`;
    },
    load(url = this.url) {
      this.$store.dispatch('loading', true);
      axios
        .get(url)
        .then(({ data }) => {
          this.pagination = data;
          this.travelPlans = data.data && data.data.length ? data.data : data;
          this.$store.dispatch('loading', false);
          this.$nextTick(() => {
            startMyTravelPlansGuide(this.user, { i18n: this.$i18n });
          });
        })
        .catch((error) => {
          console.log('Travel plans load error: ', error);
          this.$store.dispatch('loading', false);
        });
    },
  },
};
</script>
